var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggridDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dot Menu Vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.91419 14.5835C7.68502 14.5835 7.49752 14.771 7.50002 15.0002C7.50002 15.2293 7.68752 15.4168 7.91669 15.4168C8.14586 15.4168 8.33336 15.2293 8.33336 15.0002C8.33336 14.771 8.14586 14.5835 7.91419 14.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0812 14.5835C11.852 14.5835 11.6645 14.771 11.667 15.0002C11.667 15.2293 11.8545 15.4168 12.0837 15.4168C12.3129 15.4168 12.5004 15.2293 12.5004 15.0002C12.5004 14.771 12.3128 14.5835 12.0812 14.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.91419 9.5835C7.68502 9.5835 7.49752 9.771 7.50002 10.0002C7.50002 10.2293 7.68752 10.4168 7.91669 10.4168C8.14586 10.4168 8.33336 10.2293 8.33336 10.0002C8.33336 9.771 8.14586 9.5835 7.91419 9.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0812 9.5835C11.852 9.5835 11.6645 9.771 11.667 10.0002C11.667 10.2293 11.8545 10.4168 12.0837 10.4168C12.3129 10.4168 12.5004 10.2293 12.5004 10.0002C12.5004 9.771 12.3128 9.5835 12.0812 9.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.91419 4.5835C7.68502 4.5835 7.49752 4.771 7.50002 5.00016C7.50002 5.22933 7.68752 5.41683 7.91669 5.41683C8.14586 5.41683 8.33336 5.22933 8.33336 5.00016C8.33336 4.771 8.14586 4.5835 7.91419 4.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.0812 4.5835C11.852 4.5835 11.6645 4.771 11.667 5.00016C11.667 5.22933 11.8545 5.41683 12.0837 5.41683C12.3129 5.41683 12.5004 5.22933 12.5004 5.00016C12.5004 4.771 12.3128 4.5835 12.0812 4.5835Z",
    fill: "#656461",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggridDragIcon);
export default __webpack_public_path__ + "static/media/aggrid-drag-icon.efa3f7418292d4cf5f4e1710d2edb716.svg";
export { ForwardRef as ReactComponent };